const GA_ID = "G-7495RJR39Z";

export function loadAnalytics() {
  const productionHost = ["corpresi.com", "www.corpresi.com"].includes(window.location.hostname);
  if (!productionHost || document.querySelector(`script[data-ga="${GA_ID}"]`)) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args) => window.dataLayer.push(args);
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.dataset.ga = GA_ID;
  document.head.appendChild(script);
}

export function trackEvent(name, data = {}) {
  window.gtag?.("event", name, data);
}
